module.exports = __webpack_public_path__ + "static/CSF3-bc0b966cba2e8bc9a1eacb6b46884037.png";